// DimensionsInput — drie zijden L × B × H.

import React from 'react';
import { Stack, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** Haalt de volgorde van de drie maten uit het itemlabel, bijv. "(B × H × D in mm)". */
function axisLabels(itemLabel, fallback) {
    const m = /([LBHD])\s*[×x]\s*([LBHD])\s*[×x]\s*([LBHD])/.exec(itemLabel || '');
    return m ? [m[1], m[2], m[3]] : fallback;
}

export default function DimensionsInput({ value, onChange, unit, disabled, itemLabel }) {
    const { t } = useTranslation();
    const [la, lb, lc] = axisLabels(itemLabel, [
        t('input.dimensions.length'), t('input.dimensions.width'), t('input.dimensions.height'),
    ]);
    const v = value || { l: '', w: '', h: '' };
    const update = (key) => (ev) => onChange({ ...v, [key]: ev.target.value });

    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
            <TextField
                label={`${la} (${unit || 'mm'})`}
                type="number"
                inputMode="decimal"
                value={v.l}
                onChange={update('l')}
                disabled={disabled}
            />
            <TextField
                label={`${lb} (${unit || 'mm'})`}
                type="number"
                inputMode="decimal"
                value={v.w}
                onChange={update('w')}
                disabled={disabled}
            />
            <TextField
                label={`${lc} (${unit || 'mm'})`}
                type="number"
                inputMode="decimal"
                value={v.h}
                onChange={update('h')}
                disabled={disabled}
            />
        </Stack>
    );
}
